<template>
  <teleport to="body">
    <!-- 遮罩层 -->
    <transition name="fade">
      <div 
        v-if="show" 
        class="popup-overlay"
        @click="handleOverlayClick"
      ></div>
    </transition>
    
    <!-- 右侧侧边栏弹窗 -->
    <transition name="slide-right">
      <div v-if="show" class="side-popup">
        <div class="popup-content">
          <div class="menu-header">
            <svg 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              @click="$emit('close')"
              class="close-icon"
            >
              <path d="M18 6L6 18M6 6L18 18" stroke="#666" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
          <div class="menu-list">
            <slot></slot>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup>
import { watch } from 'vue'

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  closeOnClickOverlay: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['close', 'update:show'])

const handleOverlayClick = () => {
  if (props.closeOnClickOverlay) {
    emit('close')
    emit('update:show', false)
  }
}

// 监听 show 变化，防止 body 滚动
watch(() => props.show, (newVal) => {
  if (typeof document !== 'undefined') {
    if (newVal) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
  }
})
</script>

<style scoped lang="scss">
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1999;
}

.side-popup {
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  left: auto !important;
  width: 70% !important;
  max-width: 300px !important;
  z-index: 2000;
  height: 100% !important;
  
  .popup-content {
    background: #fff;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    
    .menu-header {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 40px;
      padding-top: 10px;
      
      .close-icon {
        cursor: pointer;
        transition: opacity 0.2s;
        
        &:hover {
          opacity: 0.7;
        }
      }
    }
    
    .menu-list {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding-left: 10px;
    }
  }
}

// 遮罩层淡入淡出动画
.fade-enter-active {
  transition: opacity 0.3s ease;
}

.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

// 右侧弹窗滑入滑出动画
.slide-right-enter-active {
  transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;
}

.slide-right-leave-active {
  transition: transform 0.25s cubic-bezier(0.55, 0.06, 0.68, 0.19) !important;
}

.slide-right-enter-from {
  transform: translateX(100%) !important;
}

.slide-right-leave-to {
  transform: translateX(100%) !important;
}
</style>
